import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model["orderNumber"]): string | number =>
	item ?? "";

export default cellProcessing;
